import * as React from 'react'
import Link from 'gatsby-link'
import Image from 'gatsby-image'
import TripadvisorIcon from '../Icons/Tripadvisor'
import GoogleIcon from '../Icons/Google'
import FacebookIcon from '../Icons/Facebook'
import InstagramIcon from '../Icons/Instagram'

import s from './styles.module.css'

const YEAR = new Date().getFullYear()

const Icon = ({ children }) => <div>{children}</div>

const Footer = ({ locale, logo }) => (
  <footer className={s.footer}>
    <section className={s.nav}>
      <Link to="/">
        <Image
          className={s.logo}
          sizes={logo.sizes}
          alt="Augusta Insula Lastovo"
        />
      </Link>
      <div className={s.links}>
        <a
          href="https://www.instagram.com/augusta_insula_lastovo"
          rel="nofollow noopener"
        >
          <Icon>
            <InstagramIcon className={s.icon} />
          </Icon>
        </a>
        <a
          href="https://www.tripadvisor.com/Restaurant_Review-g2039687-d2206293-Reviews-Konoba_Augusta_Insula-Zaklopatica_Lastovo_Island_Dubrovnik_Neretva_County_Dalmat.html"
          rel="nofollow noopener"
        >
          <Icon>
            <TripadvisorIcon className={s.icon} />
          </Icon>
        </a>
        <a
          href="https://www.facebook.com/AugustaInsulaLastovo"
          rel="nofollow noopener"
        >
          <Icon>
            <FacebookIcon className={s.icon} />
          </Icon>
        </a>
      </div>
      <ul className={s.routes}>
        <li>
          <Link className={s.link} to={`/${locale}/restaurant`}>
            Restaurant
          </Link>
        </li>
        <li>
          <Link className={s.link} to={`/${locale}/accommodation`}>
            Accommodation
          </Link>
        </li>
        <li>
          <Link className={s.link} to={`/${locale}/docking`}>
            Docking
          </Link>
        </li>
        <li>
          <Link className={s.link} to={`/${locale}/tours`}>
            Adventure Tours
          </Link>
        </li>
        <li>
          <Link className={s.link} to={`/${locale}/contact`}>
            How to Find Us
          </Link>
        </li>
      </ul>
    </section>
    <section className={s.copyright}>
      <div>
        &copy; {YEAR} Lago d.o.o. | Biskupa Đivoje 3, 20290 Lastovo | OIB:
        77823200910 | Subjekt upisan kod Trgovačkog suda u Dubrovniku Tt-17/2897-1 |
        Temeljni kapital u iznosu od 20,000,00 Kn uplacen u cijelosti | Bank
        name: Splitska Banka | IBAN: HR8323300031153203079 | Radno vrijeme:
        Pon - Ned 09:00 - 23:59
      </div>
      <a href="https://appac.us">
        Mobile and web product development studio Appacus
      </a>
    </section>
  </footer>
)

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer/index.js